import Vue from 'vue'
import Router from 'vue-router'
import propertyRoute from '@/views/Property/router'
import Home from '@/views/Home.vue'
import PageNotFound from '@/views/PageNotFound'
import About from '@/views/About.vue'
import ContactUs from '@/views/ContactUs.vue'
import LegalConsultant from '@/views/ManagementService/LegalConsultant'
import VillaManagement from '@/views/ManagementService/VillaManagement'
import EstateManagement from '@/views/ManagementService/EstateManagement'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import TermOfUse from '@/views/TermOfUse'
import ListProperty from '@/views/ListProperty'
import OurBrandsPage from '@/views/OurBrands/OurBrandsPage'
import ManagementServicesPage from '@/views/ManagementServices/ManagementServicesPage'

Vue.use(Router)

export function createRouter () {
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/property',
        component: () => import(/* webpackChunkName: "property" */ '@/views/Property/Index.vue'),
        children: propertyRoute,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/about-us',
        name: 'AboutUs',
        component: About,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/legal-consultant',
        name: 'LegalConsultant',
        component: LegalConsultant,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/villa-management',
        name: 'VillaManagement',
        component: VillaManagement,
        meta: {
          heroSectionText: ''
        }
      },
      {
        path: '/estate-management',
        name: 'EstateManagement',
        component: EstateManagement
      },
      {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy
      },
      {
        path: '/term-of-use',
        name: 'TermOfUse',
        component: TermOfUse
      },
      {
        path: '/list-property',
        name: 'ListProperty',
        component: ListProperty
      },
      {
        path: '/our-brands',
        name: 'OurBrands',
        component: OurBrandsPage
      },
      {
        path: '/management-services',
        name: 'ManagementServices',
        component: ManagementServicesPage
      },
      {
        path: '/page-not-found',
        name: 'PageNotFound',
        component: PageNotFound
      }
    ]
  })
}
